import { createRoot, hydrateRoot } from 'react-dom/client';

// scroll bar
// 以下読み込まないとドロワー内でスクロールできない
// importしてるだけ?でコード上で使用されていないように見えたので必要ないと判断したが、実際には必要である
// かなりハマったのでメモとして残す
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// map
import 'mapbox-gl/dist/mapbox-gl.css';

// google-fonts
//
// 読み込むのは実際に使う Public Sans だけに絞っている。
// もとは Roboto / Inter / Poppins も読み込んでいたが、フォントを切り替えるUIは
// 用意しておらず(src/config.ts の fontFamily が 'Public Sans' 固定)、
// 1文字も使われないフォントファイルを毎回ダウンロードさせている状態だった。
// フォント切替を実装する場合は、その画面側で必要なものを動的に読むこと。
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project import
import App from './App';
import { ConfigProvider } from 'contexts/ConfigContext';
import { hasArticle, loadArticle } from 'const/blog/registry';

const container = document.getElementById('root') as HTMLElement;

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

// ビルド時に scripts/prerender.js が描画済みのHTMLを書き出しているため、
// 本番ではこの時点で #root の中身が埋まっている。
// その場合は描き直さず hydrateRoot でそのDOMを引き継ぎ、操作可能な状態にする
// (開発サーバーなど中身が空のときは通常どおり createRoot で描画する)。
const render = () => {
  if (container.hasChildNodes()) {
    hydrateRoot(
      container,
      <ConfigProvider>
        <App />
      </ConfigProvider>
    );
  } else {
    const root = createRoot(container!);
    root.render(
      <ConfigProvider>
        <App />
      </ConfigProvider>
    );
  }
};

/**
 * いま開いているURLが記事ページなら、その slug を返す。
 * basename を付けて配信する場合があるので、先に取り除いてから判定する。
 */
const currentArticleSlug = (): string | undefined => {
  const basename = process.env.REACT_APP_BASE_NAME ?? '';
  let path = window.location.pathname;
  if (basename && basename !== '/' && path.startsWith(basename)) {
    path = path.slice(basename.length);
  }
  return path.replace(/\/+$/, '').match(/^\/blog\/([a-z0-9-]+)$/)?.[1];
};

// 記事の本文は、全記事ぶんをまとめて持たず、開かれた1本だけを動的に読み込んでいる
// (src/const/blog/registry.ts)。
//
// ここで描画の前に読み込みを終わらせているのは、ハイドレーションのため。
// プリレンダリングしたHTMLには本文が入っているので、本文が未読込のまま
// hydrateRoot を呼ぶと、Reactが描くもの(本文なし)とHTML(本文あり)が食い違い、
// ページ全体を描き直してしまう。待っている間もプリレンダ済みのHTMLが
// そのまま表示されているため、利用者から見て待たされる時間は増えない。
const slug = currentArticleSlug();
if (slug && hasArticle(slug)) {
  loadArticle(slug).finally(render);
} else {
  render();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
